import React, { useEffect } from "react";
import * as Constants from "../../consts/Constants.js";
import Marker from "./Marker";
import Axios from "axios";
import Alert from "../../components/common/SnackAlert.js";
import ReportsExpanded from "./ReportsExpanded.js";
import ReportsTable from "./ReportsTable";
import { generalErrors } from "../../consts/ErrorMessages.js";
import Style from "../../styles/js/StyleReports.js";
import { MapContainer, TileLayer } from "react-leaflet";

export default function Reports() {
  const style = Style();
  const TIMER = 60000;

  const [state, setState] = React.useState(null);
  const [map, setMap] = React.useState(null);
  const [entries, setEntries] = React.useState({ data: [] });
  const [centerMap, setCenterMap] = React.useState({
    lat: Constants.LATITUD_AYACUCHO,
    lng: Constants.LONGITUD_AYACUCHO,
  });
  const [reportSelected, setReportSelected] = React.useState({});
  const [open, setOpen] = React.useState(false);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [disabledButtons, setDisabledButtons] = React.useState(false);

  const handleViewMap = (row) => {
    let newCenter = {
      lat: row.location.latitude,
      lng: row.location.longitude,
    };
    setReportSelected(row);
    setCenterMap(newCenter);
    if (map != null) map.setView([newCenter.lat, newCenter.lng], 18);
  };

  const getReports = () => {
    let source = Axios.CancelToken.source();
    Axios.get(Constants.FINAL_URL_REPORTS + "all", {
      cancelToken: source.token,
    })
      .then((response) => {
        let data = [];
        response.data.forEach((reportItem) => {
          data.push(reportItem);
        });
        setEntries({ data: data });
      })
      .catch(function () {
        setAlertOpen(true);
      });
    return () => source.cancel();
  };

  const handleClickOpen = (event, row) => {
    setOpen(true);
    setReportSelected(row);
  };

  const updateState = (report, newState) => {
    setDisabledButtons(true);
    let auth = JSON.parse(localStorage.getItem("auth"));

    let reply = {
      requestId: report.id,
      serviceId: Constants.SERVICE_REPORT_ID,
      userId: auth.userId,
      code: newState,
    };

    Axios.post(
      Constants.FINAL_URL_REPORTS + "requests/" + report.id + "/replies",
      reply
    )
      .then((response) => {
        if (response.status === Constants.RESPONSE_OK) {
          setReportSelected({ ...reportSelected, state: newState });
          getReports();
        } else {
          setAlertOpen(true);
        }
        setDisabledButtons(false);
      })
      .catch(() => {
        setDisabledButtons(false);
        setAlertOpen(true);
      });
  };

  useEffect(() => {
    getReports();
    let interval = setInterval(() => getReports(), TIMER);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className={style.mainContainer}>
      <div className={style.tableContainer}>
        <ReportsTable
          {...{ entries, handleViewMap, reportSelected, handleClickOpen }}
        />
      </div>
      <div className={style.mapContainer}>
        <MapContainer
          style={{
            height: "100%",
            width: "100%",
            overflow: "hidden",
            zIndex: 399,
          }}
          center={[centerMap.lat, centerMap.lng]}
          zoom={13}
          scrollWheelZoom={true}
          whenCreated={setMap}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {reportSelected.location !== undefined ? (
            <Marker
              lat={reportSelected.location.latitude}
              lng={reportSelected.location.longitude}
            />
          ) : null}
        </MapContainer>
      </div>

      <ReportsExpanded
        {...{ open, setOpen, reportSelected, updateState, disabledButtons }}
      />
      <Alert
        open={alertOpen}
        setOpen={setAlertOpen}
        mensaje={generalErrors.server}
        severity="error"
      ></Alert>
    </div>
  );
}
